var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toPromise } from "src/shared/api/promise";
import { convertBuiltCampaignComponentResponseToBuiltComponentResponse } from "src/shared/data-loading/shared/convert/convertBuiltCampaignComponentResponseToBuiltComponentResponse";
export default function handleInitializeAllCampaigns(parameters) {
    return __awaiter(this, void 0, void 0, function* () {
        const builtCampaigns = yield toPromise(parameters.campaignEndpoints.getBuiltCampaigns());
        builtCampaigns.forEach((builtCampaign) => {
            parameters.inboundEventBus.emit("built_campaign_updated", {
                builtCampaign,
            });
            builtCampaign.components.forEach((component) => {
                parameters.inboundEventBus.emit("built_component_updated", {
                    builtComponent: convertBuiltCampaignComponentResponseToBuiltComponentResponse({
                        campaignId: builtCampaign.campaign_id,
                        campaignState: builtCampaign.state,
                        sourceClientId: parameters.sourceClientId,
                        builtCampaignComponent: component,
                    }),
                });
            });
        });
    });
}
